
var app = angular.module('directives.paymentConfirm', []);

require('./directives/paymentConfirm.js');
require('./stylesheets/paymentConfirm.scss');
require('./templates/index.html');

module.exports = app;



/*****************
 ** WEBPACK FOOTER
 ** ./app/directives/paymentConfirm/index.js
 ** module id = 197
 ** module chunks = 1
 **/